import React from "react";
import styled from "styled-components";

import { ReactComponent as FolderZip } from "../../svgs/FolderZip.svg";
import { ReactComponent as TableRows } from "../../svgs/TableRows.svg";

const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  background: #FFFFFF;
  border-radius: 8px;
  border: 1px solid #DADCE0;
  margin-top: 25px;
  box-shadow: 0px 10px 20px rgba(173, 174, 174, 0.25);
  width: 100%;
`;

const HeaderBox = styled.div`
  display: flex;
  border-bottom: 1px solid #DADCE0;
  align-content: space-between;
  padding-left: 20px;
  padding-right: 20px;
  padding: 1em 20px;
  flex-wrap: wrap;
  align-content: center;
`;

const ModuleBox = styled.div`
  display: flex;
  align-content: space-around;
  width: 80%;
`;

const ModuleType = styled.div`
  font-family: Work Sans;
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 23px;
  display: flex;
  align-items: center;
  color: #000000;
`;

const DownloadAllLink = styled.div`
  margin-left: auto;
  font-family: Work Sans;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 19px;
  color: #005AA9;
  display: flex;
  align-items: center;
  text-align: right;
  cursor: pointer;
`;

const FileRow = styled.div`
  display: flex;
  height: 60px;
  align-items: center;
  color: #005AA9;
  padding-left: 20px;
  align-content: space-around;
  cursor: pointer;
  border-top: ${({withBorder}) => withBorder && "1px solid #dadce0"};
  font-family: 'Work Sans';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
`;

const DeliverablesModule = ({ type, files, handleDownload, task, ableToSeePrivilegedInfo }) => {
  const containsDeliverableFiles = files.some(file => !file.isPrivate);
  const isNotPrivilegedTask = !(task?.isPrivileged);

  const downloadAllFiles = files => {
    if (ableToSeePrivilegedInfo || isNotPrivilegedTask) {
      const deliverableFiles = files.filter(file => !file.isPrivate).map(({ id }) => id);
      for (const file of deliverableFiles) {
        handleDownload(file);
      }
    }
  };

  return (
    <MainContainer>
      <HeaderBox>
        <ModuleBox>
          <ModuleType>{type}</ModuleType>
        </ModuleBox>
        {containsDeliverableFiles && (ableToSeePrivilegedInfo || isNotPrivilegedTask) && <DownloadAllLink onClick={() => downloadAllFiles(files)}>Download all</DownloadAllLink>}
      </HeaderBox>
      <div>
        { (ableToSeePrivilegedInfo || isNotPrivilegedTask) ?
          files.map((file, index) => {
            const extension = file.name.split(".")[1];
            return (
              <FileRow key={file.id} withBorder={index !== 0} onClick={() => ((ableToSeePrivilegedInfo || isNotPrivilegedTask) ? handleDownload([file.id]) : null)}>
                {
                  extension === "zip" ?
                    <FolderZip style={{ "padding-right": "8px" }} /> :
                    <TableRows style={{ "padding-right": "8px" }} />
                }
                {file.name}
              </FileRow>
            );
          }) : <FileRow>{files.length === 1 ? "1 file attached" : `${files.length} files attached`}</FileRow>
        }
      </div>
    </MainContainer>
  );
};

export default DeliverablesModule;
